module.exports = __webpack_public_path__ + "static/media/36x36-3.95293c35.png";